import { Typography } from "@mui/material";
import SecondaryLink from "../../components-redesign/StyledLinks/SecondaryLink";
import { useLocalTranslationState } from "../../context/AppContext/AppContext";
import { styled } from "@mui/material/styles";

const InlineContainer = styled("div")(({ theme }) => ({
  paddingTop: theme.spacing(4),
  paddingBottom: theme.spacing(5),
  display: "flex",
  alignItems: "center",
  flexWrap: "wrap",
  gap: "4px",
}));

const PrivacyPolicy = () => {

  const { _translate } = useLocalTranslationState();

  return (
    <InlineContainer>
      <Typography variant="subtitle2" fontWeight="400">
        {_translate("By creating an account, you agree to Videojet's")}
      </Typography>
      <SecondaryLink
        text={_translate("PrivacyPolicy")}
        href="https://www.videojet.com/us/homepage/general/privacy-policy.html"
        target="_blank"
      />
    </InlineContainer>
  );
};

export default PrivacyPolicy;